"use client"

import { useSharedUiTranslations } from "@/components/i18n/ui-control-labels-context"
import type { ReactNode } from "react"
import { ArrowUpDown, ChevronDown } from "lucide-react"
import { Button } from "@/components/ui/button"
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu"

export type MobileTableSortOption = {
  id: string
  content: ReactNode
  disabled?: boolean
}

export function TableMobileSort({ options, onSort }: {
  options: MobileTableSortOption[]
  onSort: (headerId: string) => void
}) {
  const tUi = useSharedUiTranslations("TableMobileSort")
  if (!options.length) return null

  return (
    <div className="p-3 sm:hidden">
      <DropdownMenu modal={false}>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" className="w-full justify-between">
            <span className="flex items-center gap-2"><ArrowUpDown className="h-4 w-4" /><span key={tUi("sortBy")}>{tUi("sortBy")}</span></span>
            <ChevronDown className="h-4 w-4 text-muted-foreground" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="w-[var(--radix-dropdown-menu-trigger-width)] max-w-[calc(100vw-2rem)]">
          {options.map((option) => (
            <DropdownMenuItem key={option.id} disabled={option.disabled} onSelect={() => onSort(option.id)}>
              {option.content}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  )
}
